var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',[_c('app-sheet',{attrs:{"outlined":_vm.outlined}},[_c('app-img',_vm._g(_vm._b({},'app-img',_vm.$attrs,false),_vm.$listeners))],1),_vm._t("default"),(!_vm.$slots.default && _vm.caption)?_c('figcaption',{staticClass:"text-subtitle-2 text-center text-capitalize mt-3",domProps:{"textContent":_vm._s(_vm.caption)}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }